import gsap from 'gsap';

class Blockquote {
    constructor({ element }) {
        this.element = element;
    }

    init() {
        let text = this.element.querySelector( 'p' );
        // let innerText = text.querySelector('.split-inner');
        // if(innerText) {
        //     innerText.classList.remove('split-inner');
        //     let innerSplit = new SplitText(innerText, { type: "words", wordsClass: innerText.classList.value });
        //     innerText.outerHTML = innerText.innerHTML;
        // }
        let splitInner = new SplitText( text, { type: "lines", linesClass: "splitted-line-inner" } );
        new SplitText( text, { type: "lines", linesClass: "splitted-line" } );

        this.animation = gsap.timeline({ paused: true });

        this.animation.eventCallback( "onStart", function() {
            // document.body.dispatchEvent( new Event( '2022-sia-preflight-sectiontraveladvisory-mid' ) );
        }).from(splitInner.lines, {
            yPercent: 101,
            duration: 1.5,
            stagger:0.2,
            ease: "expo.out"
        }, 0.3 ).fromTo( this.element.querySelector( '.quote-line .line' ), {
            xPercent: -100
        }, {
            xPercent: 0,
            duration: 0.3
        }, '-=1' ).fromTo (this.element.querySelector( '.by' ), {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.3
        }, '-=0.8' );

        this.element.animation = this.animation;

        this.element.addEventListener( 'CallEvent', ( e ) => {
            this.animate();
        } );
    }

    animate() {
        this.animation.play();
    }
}

export default function () {
    document.querySelectorAll( '[data-scroll-call="quote"]' ).forEach( ( element ) => {
        let quote = new Blockquote( { element } );
        setTimeout( () => {
            quote.init();
        }, 500 );
    } );
}